import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import ProfilePhotoWithoutImage from 'components/atoms/ProfilePhotoWithoutImage';
import {useUserStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import React, {useEffect, useImperativeHandle, useState} from 'react';
import {
  Modal,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Image,
  Text,
} from 'react-native';
import strings from 'translations/index.web';
import styleSheet from './styles';
import {INPUT_CONFIG} from 'constants/webInputConfig';

export interface ChangePhotoModalHandle {
  switchVisible: () => void;
}

type ChangePhotoProps = {
  onDeletePhotoPress: () => void;
};

const ChangePhotoWeb = observer(
  React.forwardRef<ChangePhotoModalHandle, ChangePhotoProps>((props, ref) => {
    const theme = useTheme();
    const styles = styleSheet(theme);
    const [visible, setVisible] = useState(false);
    const userStore = useUserStore();

    useImperativeHandle(ref, () => ({
      switchVisible() {
        setVisible(!visible);
      },
    }));

    const onPressOut = () => {
      setVisible(false);
    };

    const saveStyleButton = (
      <LongRectangleTextButton
        onPress={() => userStore.setImage(userStore.user?.image ?? '')}
        title={strings.profile.save}
        backgroundColor={theme.colors.cornflowerBlue}
        buttonStyle={styles.buttonCommonStyle}
        titleColor={styles.saveButtonTextColor}
      />
    );

    const deleteStyleButton = (
      <LongRectangleTextButton
        onPress={userStore.deletePhoto}
        title={strings.profile.deletePhoto}
        backgroundColor={theme.colors.white}
        buttonStyle={styles.buttonCommonStyle}
        titleColor={styles.deleteButtonTextColor}
      />
    );

    const ModalHeader = (
      <View style={styles.modalHeader}>
        <Text style={styles.headerTextStyle}>
          {strings.profile.profilePhoto}
        </Text>
        <TouchableOpacity style={styles.crossContainter} onPress={onPressOut}>
          <Image
            style={styles.crossImage}
            source={theme.images.crossTransparent}
          />
        </TouchableOpacity>
      </View>
    );

    const ModalPhoto = (
      <View style={styles.modalPhotoContainer}>
        <label htmlFor={'ImagePicker'}>
          {userStore.user?.image ? (
            <Image
              source={{uri: userStore.user?.image}}
              style={styles.modalPhoto}
            />
          ) : (
            <ProfilePhotoWithoutImage
              isBigPhoto={true}
              name={userStore.fullUserName}
              isPhotoOnTheHomeGreeting={false}
            />
          )}
          <View style={styles.penContainer}>
            <Image
              source={
                userStore.user?.image
                  ? theme.images.pen
                  : theme.images.profilePhotoPurple
              }
              style={
                userStore.user?.image
                  ? styles.addImagePen
                  : styles.addImagePhoto
              }
            />
          </View>
        </label>
      </View>
    );

    const ModalButton = (
      <View style={styles.buttonContainer}>
        {userStore.user?.image === null ? saveStyleButton : deleteStyleButton}
      </View>
    );

    return (
      <Modal
        animationType="slide"
        onRequestClose={() => {}}
        transparent={true}
        visible={visible}>
        <TouchableOpacity
          style={[styles.defaultContainerStyle]}
          activeOpacity={1}
          onPressOut={onPressOut}>
          <TouchableWithoutFeedback>
            <View style={styles.defaultModalWindowStyle}>
              {ModalHeader}
              {ModalPhoto}
              {ModalButton}
            </View>
          </TouchableWithoutFeedback>
        </TouchableOpacity>
        <input
          style={styles.inputStyle}
          id={INPUT_CONFIG.inputId}
          accept={INPUT_CONFIG.imageFormats}
          type={INPUT_CONFIG.inputType}
          onChange={e => {
            e.target.files &&
              userStore.changePhoto(
                e.target.files[0],
                URL.createObjectURL(e.target.files[0]),
              );
          }}
        />
      </Modal>
    );
  }),
);

export default ChangePhotoWeb;
